import { iconFor } from '../lib/icons';
import type { HourlyEntry } from '../types';

export default function HourlyStrip({
  hourly,
  timeZone,
}: {
  hourly: HourlyEntry[];
  timeZone: string;
}) {
  return (
    <section>
      <h2 className="text-xs uppercase tracking-wider opacity-70 mb-2">Hourly</h2>
      <div className="overflow-x-auto -mx-4 px-4">
        <div className="flex gap-2 pb-2">
          {hourly.slice(0, 24).map((h) => {
            const Icon = iconFor(h.condition);
            const t = new Date(h.time).toLocaleTimeString('en-US', {
              hour: 'numeric',
              timeZone,
            });
            return (
              <div
                key={h.time}
                className="flex flex-col items-center gap-1 bg-white/10 backdrop-blur-sm rounded-lg p-2 min-w-[60px]"
              >
                <div className="text-[11px] opacity-80">{t}</div>
                <Icon className="w-6 h-6 stroke-1" />
                <div className="text-sm font-medium tabular-nums">{h.tempF}°</div>
                <div className="text-[10px] text-blue-200 h-3">
                  {h.precipPct > 0 ? `${h.precipPct}%` : ''}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
